import React, { BaseSyntheticEvent, useRef, useState } from 'react';
import { Child, TAddChildProps } from './AddChild.types';
import { useTranslation } from 'react-i18next';
import { DEFAULT_HEADERS } from 'src/shared/constants';
import useAuth from 'src/hooks/useAuth';

const AddChild: React.FC<TAddChildProps> = (props: TAddChildProps): React.ReactElement => {
	const {t} = useTranslation();
	const formRef = useRef() as React.MutableRefObject<HTMLFormElement>;
	const {setReFetch, setIsAddChildMode, setIsAddingChild, isAddingChild, reFetch, child} = props;
	const { getToken } = useAuth();

	const [currentChild, setCurrentChild] = useState<Child>(child || {});

	const registerChild = async (e: BaseSyntheticEvent) => {
		setIsAddingChild(true);
		e.preventDefault();
		const formData = Object.fromEntries(new FormData(formRef.current));
		const payload: Child = {
			firstname: formData.firstname as string,
			lastname: formData.lastname as string,
			age: parseInt(formData.age as string, 10) as number,
			allergy: formData.allergy as string
		};

		const token = getToken();
		const requestString = JSON.stringify(payload);
		const childIdPart = child.id ? `/${child.id}` : '';
		const url = `${import.meta.env.VITE_API_URL}/children${childIdPart}`;
		const method = child.id ? 'PUT' : 'POST';
		const body = requestString;
		const headers = {
			...DEFAULT_HEADERS,
			Authorization: `Bearer ${token}`,
		};
		const registerChildResponse = await fetch(url, {
			method,
			body,
			headers,
		});
		if (registerChildResponse.status === 200) {
			setReFetch(!reFetch);
			setIsAddChildMode(false);
			setIsAddingChild(false);
		}
	};

    return <form ref={formRef} className={'children-data'}>
			<div className="input-container">
				<label
					htmlFor={'firstname'}>{t('pages.buySubscription.steps.0.firstName')}</label>
				<input
					name={'firstname'}
					id={'firstname'}
					type="text"
					value={currentChild.firstname || ''}
					onInput={(e: BaseSyntheticEvent) => {
						setCurrentChild({
							...currentChild,
							firstname: e.target.value,
						})
					}}
					required
				/>
			</div>
			<div className="input-container">
				<label
					htmlFor={'lastname'}>{t('pages.buySubscription.steps.0.lastName')}</label>
				<input
					name={'lastname'}
					id={'lastname'}
					type="text"
					value={currentChild.lastname || ''}
					required
					onInput={(e: BaseSyntheticEvent) => {
						setCurrentChild({
							...currentChild,
							lastname: e.target.value,
						})
					}}
				/>
			</div>
			<div className="input-container">
				<label
					htmlFor={'allergy'}>{t('pages.buySubscription.steps.0.allergy')}</label>
				<input
					name={'allergy'}
					id={'allergy'}
					type="text"
					value={currentChild.allergy || ''}
					required
					onInput={(e: BaseSyntheticEvent) => {
						setCurrentChild({
							...currentChild,
							allergy: e.target.value,
						})
					}}
				/>
			</div>
			<div className="input-container">
				<label htmlFor={'age'}>{t('pages.buySubscription.steps.0.age')}</label>
				<input
					name={'age'}
					id={'age'}
					type="number"
					value={currentChild.age || ''}
					onInput={(e: BaseSyntheticEvent) => {
						setCurrentChild({
							...currentChild,
							age: parseInt(e.target.value, 10),
						})
					}}
					required/>
			</div>
			<div className="button-container">
				<button
					className={'scroll-to-button'}
					onClick={registerChild}
					disabled={isAddingChild}
				>
					{t('common.continue')}
				</button>
			</div>
		</form>;
}

export default AddChild;
